<template>
  <div v-if="isOpen" class="modal-overlay">
    <div class="modal-content">
      <component :is="componentToRender" v-bind="componentProps" @close="closeModal" @substitute="handleSubstitute" @runnerout="handleRunner" @specialCase="handleSpecialCase" @prevplay="handleHistoryPlay"></component>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    componentToRender: {
      type: [String, Object],
      required: true,
    },
    componentProps: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    handleSubstitute(substitutId, selectedPlayerId) {
      this.$emit('substitute', substitutId, selectedPlayerId, true);
      // Perform substitution logic here
      this.$emit('close');
    },
    handleRunner(selectedPlayerId) {
      this.$emit('runnerout', selectedPlayerId);
      // Perform substitution logic here
      this.$emit('close');
    },
    handleSpecialCase(selectedPlayer) {
      this.$emit('player-selected', selectedPlayer);
      // Perform substitution logic here
      this.$emit('close');
    },
    handleHistoryPlay(selectedPlay) {
      this.$emit('prevplay', selectedPlay);
      // Perform substitution logic here
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  width: 90%;
  border-radius: 8px;
  overflow-y: auto;
  position: relative;
  padding: 20px;
}

</style>
